import React, { useEffect, useState } from "react";
import { api } from "@/api/client";
import { Section, Empty } from "@/components/ui/kit";
import { fmtDate } from "@/utils/format";

export default function MyProfile() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { api.get("/donors/me").then(r => setD(r.data.data)).catch(e => setErr(e.response?.data?.message)); }, []);
  if (err) return <Empty title="Profile unavailable" note={err} testid="profile-error" />;
  if (!d) return <div className="text-muted-foreground">Loading…</div>;

  const isInd = d.donorType === "INDIVIDUAL";
  return (
    <div className="space-y-6" data-testid="my-profile">
      <Section title="My Profile" kicker={<span className="mono">{d.donorCode}</span>} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Card title="Contact">
          <Row k="Email" v={isInd ? d.individual?.email : d.corporate?.contactPersonEmail} />
          <Row k="Phone" v={d.primaryContactNo} />
          <Row k="WhatsApp" v={d.whatsappNo} />
          <Row k="PAN" v={d.panNumber} mono />
        </Card>
        <Card title="Address">
          <Row k="City" v={d.city} />
          <Row k="State" v={d.state} />
          <Row k="Country" v={d.country} />
          <Row k="Pincode" v={d.pincode} />
        </Card>
        <Card title={isInd ? "Personal" : "Company"}>
          {isInd ? (
            <>
              <Row k="Full name" v={d.individual?.fullName} />
              <Row k="Gender" v={d.individual?.gender} />
              <Row k="DOB" v={fmtDate(d.individual?.dateOfBirth)} />
              <Row k="Nationality" v={d.individual?.nationalityName} />
              <Row k="Employer" v={d.individual?.currentEmployer} />
            </>
          ) : (
            <>
              <Row k="Company" v={d.corporate?.companyName} />
              <Row k="Company PAN" v={d.corporate?.companyPan} mono />
              <Row k="Contact person" v={d.corporate?.contactPersonName} />
              <Row k="Registered office" v={d.corporate?.registeredOfficeAddress} />
            </>
          )}
        </Card>
      </div>
    </div>
  );
}
function Card({ title, children }){ return <div className="rounded-xl border border-emerald-900/10 bg-white p-5"><div className="overline mb-3">{title}</div><div className="space-y-2 text-sm">{children}</div></div>; }
function Row({ k, v, mono }){ return <div className="flex justify-between gap-3"><span className="text-muted-foreground">{k}</span><span className={mono ? "mono text-emerald-900" : "text-emerald-950 font-medium"}>{v || "—"}</span></div>; }
